import { render } from "./SoPoLetter.vue?vue&type=template&id=8ca9286c"
import script from "./SoPoLetter.vue?vue&type=script&lang=js"
export * from "./SoPoLetter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__